export default __webpack_public_path__ + "static/media/BQ.b3f9d6f5.png";